import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    layout: 'left',
  },
  itemDesign: {},
  containerDesign: {},
};

export const featuresSlice = createSlice({
  name: 'features',
  initialState,
  reducers: {
    featuresStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        items: blockContent.items ?? [],
        heading: {
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };
      state.blockDesign = {
        layout: blockDesign.layout ?? 'left',
      };
    },
    featuresClear: () => initialState,

    featuresUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    featuresUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    featuresUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    featuresUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const { featuresStore, featuresClear, featuresUpdateIsLoading, featuresUpdateIsActive, featuresUpdateBlockContent, featuresUpdateBlockDesign } = featuresSlice.actions;

export const selectFeaturesIsLoading = (state) => state.features.isLoading;

export const selectFeaturesId = (state) => state.features.id;
export const selectFeaturesUID = (state) => state.features.uid;
export const selectFeaturesSID = (state) => state.features.sid;

export const selectFeaturesBlockContent = (state) => state.features.blockContent;
export const selectFeaturesBlockDesign = (state) => state.features.blockDesign;
export const selectFeaturesSortItems = createSelector([selectFeaturesBlockContent], ({ items }) => {
  return sortItems(items);
});
export const selectFeaturesItemDesign = (state) => state.features.itemDesign;
export const selectFeaturesContainerDesign = (state) => state.features.containerDesign;

export default featuresSlice.reducer;
